import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/AuthContext";
import ProtectedRoute from "@/lib/ProtectedRoute";
import Login from "@/pages/auth/Login";
import ForgotPassword from "@/pages/auth/ForgotPassword";
import ResetPassword from "@/pages/auth/ResetPassword";
import ModuleChooser from "@/pages/ModuleChooser";
import Dashboard from "@/pages/Dashboard";
import CalendarPage from "@/pages/CalendarPage";
import StatsPage from "@/pages/StatsPage";
import ComDashboard from "@/pages/commercial/ComDashboard";
import ComOpportunities from "@/pages/commercial/ComOpportunities";
import ComFicheCommerciale from "@/pages/commercial/ComFicheCommerciale";
import ComAppointments from "@/pages/commercial/ComAppointments";
import ComClients from "@/pages/commercial/ComClients";
import ComContracts from "@/pages/commercial/ComContracts";
import ComCommissions from "@/pages/commercial/ComCommissions";
import ComStats from "@/pages/commercial/ComStats";
import OnboardingPublic from "@/pages/onboarding/OnboardingPublic";

const protect = (el) => <ProtectedRoute>{el}</ProtectedRoute>;

function App() {
  return (
    <div className="App min-h-screen bg-brand-paper text-brand-ink">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Routes publiques */}
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/onboarding/:token" element={<OnboardingPublic />} />

            {/* Studio Hub */}
            <Route path="/" element={protect(<ModuleChooser />)} />

            {/* Module 01 — Prospection */}
            <Route path="/prospection" element={protect(<Dashboard />)} />
            <Route path="/calendrier" element={protect(<CalendarPage />)} />
            <Route path="/statistiques" element={protect(<StatsPage />)} />

            {/* Module 02 — Suivi commercial */}
            <Route path="/commercial" element={protect(<ComDashboard />)} />
            <Route path="/commercial/opportunites" element={protect(<ComOpportunities />)} />
            <Route path="/commercial/opportunites/:id" element={protect(<ComFicheCommerciale />)} />
            <Route path="/commercial/rendez-vous" element={protect(<ComAppointments />)} />
            <Route path="/commercial/clients" element={protect(<ComClients />)} />
            <Route path="/commercial/contrats" element={protect(<ComContracts />)} />
            <Route path="/commercial/commissions" element={protect(<ComCommissions />)} />
            <Route path="/commercial/statistiques" element={protect(<ComStats />)} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          classNames: {
            toast: "bg-white border border-brand-line text-brand-ink rounded-md shadow-soft",
            title: "text-brand-ink text-sm",
            description: "text-brand-subtle text-xs",
            icon: "text-brand-moss",
          },
        }}
      />
    </div>
  );
}

export default App;
